import { useMemo } from "react";
import { useUser } from "../../../../api/useUser";
import { useCanUserDoOnProject, useHasUserRole } from "../../../canUserDo";
import type { DashboardModelT } from "../schema/dashboard";

export function useDashboardPermissions(dashboard: DashboardModelT | null) {
  const user = useUser();
  const userIsSuperAdmin = useHasUserRole(user, "SUPER_ADMIN");
  const userIsAdmin = useHasUserRole(user, "ADMIN");
  const userIsAllProjectsSetuper = useHasUserRole(user, "ALL_PROJECTS_SETUPER");
  const userIsProjectSetuper = useCanUserDoOnProject("PROJECT_SETUP", dashboard?.projectId ?? "");
  const userIsDashboardEditor = useCanUserDoOnProject("DASHBOARD_EDIT", dashboard?.projectId ?? "");
  const userIsDashboardAuthor = useMemo(
    () => dashboard?.createdByUserId === user.id,
    [dashboard, user],
  );

  const isSetuperOrAbove =
    userIsSuperAdmin || userIsAdmin || userIsAllProjectsSetuper || userIsProjectSetuper;

  return useMemo(
    () => ({
      // dashboard.published = true || false
      allowSharing: userIsDashboardEditor && userIsDashboardAuthor,
      // dashboard.readonly = true || false
      allowReadModeChange: isSetuperOrAbove || (userIsDashboardEditor && userIsDashboardAuthor),
      // DELETE /dashboard/:dashboardId
      allowDeletion: isSetuperOrAbove || (userIsDashboardEditor && userIsDashboardAuthor),
      // POST /dashboard
      allowDuplication: userIsDashboardEditor,
      // UPDATE / dashboard/:dashboardId
      allowEditing:
        isSetuperOrAbove ||
        (dashboard?.readonly
          ? userIsDashboardEditor && userIsDashboardAuthor
          : userIsDashboardEditor),
    }),
    [dashboard?.readonly, isSetuperOrAbove, userIsDashboardAuthor, userIsDashboardEditor],
  );
}
